import { Link } from "react-router-dom";

import { useAdminPosts } from "@/lib/queries/use-posts";
import { useAdminProjects } from "@/lib/queries/use-projects";

export function AdminDashboard() {
  const { data: posts } = useAdminPosts();
  const { data: projects } = useAdminProjects();

  const publishedPosts = posts?.filter((p) => p.published).length ?? 0;
  const draftPosts = posts?.filter((p) => !p.published).length ?? 0;
  const totalProjects = projects?.length ?? 0;

  return (
    <div>
      <h1 className="text-[24px] md:text-[28px] font-bold text-primary mb-6 md:mb-8">Dashboard</h1>

      {/* Stats */}
      <div className="grid grid-cols-3 gap-2 md:gap-4 mb-8 md:mb-12">
        <div className="p-3 md:p-6 border border-border bg-card">
          <p className="text-[10px] md:text-[11px] text-text-muted tracking-caps uppercase mb-1 md:mb-2">
            Published
          </p>
          <p className="text-[24px] md:text-[36px] font-bold text-primary">{publishedPosts}</p>
        </div>
        <div className="p-3 md:p-6 border border-border bg-card">
          <p className="text-[10px] md:text-[11px] text-text-muted tracking-caps uppercase mb-1 md:mb-2">
            Drafts
          </p>
          <p className="text-[24px] md:text-[36px] font-bold text-text-tertiary">{draftPosts}</p>
        </div>
        <div className="p-3 md:p-6 border border-border bg-card">
          <p className="text-[10px] md:text-[11px] text-text-muted tracking-caps uppercase mb-1 md:mb-2">
            Projects
          </p>
          <p className="text-[24px] md:text-[36px] font-bold text-primary">{totalProjects}</p>
        </div>
      </div>

      {/* Quick Actions */}
      <h2 className="text-[10px] md:text-[11px] text-text-muted font-bold tracking-caps uppercase mb-3 md:mb-4">
        Quick Actions
      </h2>
      <div className="space-y-2 md:space-y-0 md:grid md:grid-cols-2 md:gap-4">
        <Link
          to="/admin/posts/new"
          className="block p-4 md:p-6 border border-border bg-card hover:border-border-hover transition-colors group"
        >
          <h3 className="text-[15px] md:text-[16px] font-bold text-text-secondary group-hover:text-primary transition-colors mb-0.5 md:mb-1">
            New Post
          </h3>
          <p className="text-[12px] md:text-[13px] text-text-muted">Write a new essay or note</p>
        </Link>
        <Link
          to="/admin/projects/new"
          className="block p-4 md:p-6 border border-border bg-card hover:border-border-hover transition-colors group"
        >
          <h3 className="text-[15px] md:text-[16px] font-bold text-text-secondary group-hover:text-primary transition-colors mb-0.5 md:mb-1">
            New Project
          </h3>
          <p className="text-[12px] md:text-[13px] text-text-muted">Add a project to showcase</p>
        </Link>
      </div>
    </div>
  );
}
